import { hinweisen } from "../../redesign/bestaetigen";
import { oeffneImEditorTab } from "./editorTab";

/**
 * Dokument im KMVS-Editor-Tab öffnen — der Aufruf für Knöpfe (IM KLICK aufrufen).
 * Ist schon ein Editor-Tab offen, kommt das Dokument dort als weiterer Tab dazu
 * und der Browser-Tab nach vorn. Lässt er sich nicht nach vorn holen (er wurde
 * nicht von diesem Tab aus geöffnet), sagt ein Hinweis, wo das Dokument jetzt ist.
 */
export function imEditorTabOeffnen(docId: number, bearbeiten = false): Promise<void> {
    return oeffneImEditorTab(docId, { bearbeiten }).then((ergebnis) => {
        if (ergebnis !== "vorhanden-hinten") return;
        void hinweisen({
            titel: "Im Editor-Tab geöffnet",
            text: "Das Dokument ist im bereits offenen KMVS-Editor-Tab als weiterer Tab dazugekommen. Bitte oben in der Tab-Leiste des Browsers dorthin wechseln.",
        });
    });
}
